import React from 'react';

interface AccessGateProps {
    allow: boolean;
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

const AccessGate: React.FC<AccessGateProps> = ({ allow, children, fallback = null }) => {
    if (allow) {
        return <>{children}</>;
    }

    return <>{fallback}</>;
};

export default AccessGate;
